
import UserImage from '../assets/user.png'
import EarthImg from '../assets/earth.png'
import ShapeImg from '../assets/trip_card_bg.png'
import BlackShapeImg from '../assets/trip_card_bg_black.png'
import whiteLogo from '../assets/white_a_logo.png'
import blackLogo from '../assets/black_a_logo.png'
import { Link } from 'react-router-dom'
import { BASE_URL_IMAGE } from '../services/ApiEndpoints'
import { countryOptions } from '../pages/adminPanel/pages/addPackingList/utils'
const TravelCard = ({ proCard, item }) => {
    const selectedCountry = item?.destinations?.length
        ? countryOptions.find((c) => c.value === item.destinations[0]?.country?.[0])
        : null;
    return (
        <Link to={`/trip-detail/${item?._id}`}>

            <div className={`w-full rounded-[20px] overflow-hidden ${proCard ? 'bg-green' : 'bg-bgprimary'} p-5 `} style={{ boxShadow: '0px 4px 16.6px 0px #00000040' }} >
                <div className={`${proCard ? 'bg-green' : 'bg-bgprimary'} flex justify-center items-center mb-3`}>
                    {/* <div className="border-2 w-12 h-12 border-bgprimary rounded-full">
                        <img
                            src={item?.creatorImage ? `${BASE_URL_IMAGE}${item?.creatorImage}` : UserImage}
                            alt="Profile"
                            className="w-full h-full rounded-full object-cover"
                        />
                    </div> */}
                    <h3 className={`text-sm font-quicksand font-bold ${proCard ? 'text-bgprimary' : 'text-dark'}`}> Westbreeze</h3>

                    {/* <div className="">
                        {proCard && (
                            <span className={` bg-[#F0D23C]  text-orange font-quicksand text-[15px] font-bold border border-white px-3 py-1 rounded-full`}>
                                PRO
                            </span>
                        )}
                    </div> */}
                    {/* <h2 className={`text-[16px] text-center font-quicksand font-bold ${proCard ? 'text-bgprimary' : 'text-dark'} `}>
                        {item?.title}
                    </h2> */}
                </div>

                <div className={`relative ${proCard ? 'bg-green' : 'bg-bgprimary'}`}>
                    <img
                        src={`${BASE_URL_IMAGE}${item?.thumbnail}`}
                        alt="Trip Image"
                        className="w-full h-[400px] object-cover rounded-[20px]"
                    />

                    <div className="absolute top-4 left-4 flex flex-col gap-2">

                        {!item?.destinations?.length || item?.destinations.length > 1 || item?.destinations?.[0]?.region ? (
                            <div className={`${proCard ? 'bg-bgprimary text-orange border-bgprimary' : 'bg-bgprimary text-orange border-white'} w-[50px] flex justify-center rounded items-center border  h-11`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 16.5L14.5 14.5L16.5 7.5L9.5 9.5L7.5 16.5ZM12 13.5C11.5833 13.5 11.2292 13.3542 10.9375 13.0625C10.6458 12.7708 10.5 12.4167 10.5 12C10.5 11.5833 10.6458 11.2292 10.9375 10.9375C11.2292 10.6458 11.5833 10.5 12 10.5C12.4167 10.5 12.7708 10.6458 13.0625 10.9375C13.3542 11.2292 13.5 11.5833 13.5 12C13.5 12.4167 13.3542 12.7708 13.0625 13.0625C12.7708 13.3542 12.4167 13.5 12 13.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z" fill="#25231B" />
                                </svg>
                            </div>
                        ) : selectedCountry ? (
                            <div className={`${proCard ? 'bg-bgprimary text-orange border-bgprimary' : 'bg-bgprimary text-orange border-white'} w-[70px] flex justify-center rounded items-center border  h-11`}>
                                <img
                                    src={`https://flagcdn.com/w320/${selectedCountry && selectedCountry?.code?.toLowerCase()}.png`}
                                    alt="Flag"
                                    className="w-full h-full object-cover rounded shadow-lg"
                                />
                            </div>
                        ) : (
                            <div className={`${proCard ? 'bg-bgprimary text-orange border-bgprimary' : 'bg-bgprimary text-orange border-white'} w-[50px] flex justify-center rounded items-center border  h-11`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 16.5L14.5 14.5L16.5 7.5L9.5 9.5L7.5 16.5ZM12 13.5C11.5833 13.5 11.2292 13.3542 10.9375 13.0625C10.6458 12.7708 10.5 12.4167 10.5 12C10.5 11.5833 10.6458 11.2292 10.9375 10.9375C11.2292 10.6458 11.5833 10.5 12 10.5C12.4167 10.5 12.7708 10.6458 13.0625 10.9375C13.3542 11.2292 13.5 11.5833 13.5 12C13.5 12.4167 13.3542 12.7708 13.0625 13.0625C12.7708 13.3542 12.4167 13.5 12 13.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 9.78333 19.2208 7.89583 17.6625 6.3375C16.1042 4.77917 14.2167 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20Z" fill="#25231B" />
                                </svg>
                            </div>
                        )}



                        <div className={`text-center ${proCard ? 'bg-orange text-white border-white' : 'bg-orange text-white border-white'}  w-fit line-clamp-2 border px-2  py-2 rounded shadow-md text-base font-quicksand font-bold`}>
                            {item?.packingStyle == 'EXTRA_PREPARED' ? 'Extra Prepared' : item?.packingStyle}
                        </div>
                        <div className={`text-center px-2 ${proCard ? 'bg-bgprimary text-dark border-white' : 'bg-bgprimary text-dark border-white'} bg-bgprimary w-fit line-clamp-2 border  py-2 rounded shadow-md text-base font-quicksand font-bold`}>
                            {item?.duration == "-1" ? 'Long Term' : `${item?.duration} ${item?.duration == 1 ? 'Day' : 'Days'}`}
                        </div>
                        {item?.tags?.slice(0, 3)?.map((item) => {
                            return (
                                <div key={item?._id} className={`text-center px-2 ${proCard ? 'bg-bgprimary text-dark border-white' : 'bg-bgprimary text-dark border-white'}  w-fit line-clamp-2 border  py-2 rounded shadow-md text-base font-quicksand font-bold`}>
                                    {item?.name}
                                </div>
                            )
                        })}
                        <div key={item?._id} className={`text-center px-2  bg-white text-dark w-fit line-clamp-2 border  py-2 rounded shadow-md text-base font-quicksand font-bold`}>
                            View more
                        </div>
                    </div>

                </div>


                <div className={`-mt-4 ${proCard ? 'bg-green' : 'bg-bgprimary'} h-48 `}>

                    <div className="w-full pb-4">
                        <div className="flex flex-col justify-center text-center mt-6">
                            <div className="flex items-center justify-between my-3">
                                <div className="flex items-center justify-start gap-4 mb-2">
                                    <div className="border-2 w-12 h-12 border-white rounded-full">
                                        <img
                                            src={item?.creatorImage ? `${BASE_URL_IMAGE}${item?.creatorImage}` : UserImage}
                                            alt="Profile"
                                            className="w-full h-full rounded-full object-cover"
                                        />
                                    </div>
                                    <h3 className={`text-sm font-quicksand font-bold ${proCard ? 'text-bgprimary' : 'text-dark'}`}>by {item?.creator}</h3>

                                </div>
                                <div className="">
                                    {proCard && (
                                        <span className={` bg-[#F0D23C]  text-orange font-quicksand text-base font-bold border border-white p-2 rounded-[6px]`}>
                                            Pro
                                        </span>
                                    )}
                                </div>
                            </div>


                            <div className="ml-2 w-full text-left">
                                <h2 className={`text-base font-roboto-mono italic font-bold line-clamp-2 ${proCard ? 'text-bgprimary' : 'text-dark'} `}>
                                    {item?.title}
                                </h2>
                                {/* <p className={`text-[14px] font-quicksand text-left font-normal ${proCard ? 'text-bgprimary' : 'text-dark'}`}>Description</p> */}
                                <p className={`text-sm text-left font-quicksand font-noraml mt-1 line-clamp-5 ${proCard ? 'text-bgprimary' : 'text-dark'}`}>{item?.description}
                                </p>


                            </div>
                        </div>
                    </div>
                    {/* <img src={proCard ? whiteLogo : blackLogo} className="absolute bottom-[3%] right-[45%] h-[15px] translate-x-[-50%] transform " alt="" /> */}
                    {/* <svg
                        className="absolute bottom-[3%] right-[40%] translate-x-[-50%] transform "
                        width="25"
                        height="33"
                        viewBox="0 0 25 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12.0591 2.65208H12.1624L14.939 11.7328L17.5181 11.0756L14.1294 0H10.0915L5.79297 14.0518L8.80614 13.2883L12.0591 2.65208Z"
                            fill={proCard ? "#fff" : "#25231B"}
                        />
                        <path
                            d="M4.34268 18.7953L0 33.0001H0.0916232C3.65128 31.6857 7.75159 30.9378 12.1118 30.9378C16.472 30.9378 20.5665 31.6863 24.1294 33.0001H24.2236L21.1364 22.9083L4.34268 18.7953ZM12.1118 28.2863C9.34102 28.2863 6.58713 28.5754 3.96124 29.1354L6.15175 21.9692L19.0349 25.1248L20.2617 29.136C17.6345 28.576 14.8807 28.2863 12.1118 28.2863Z"
                            fill={proCard ? "#fff" : "#25231B"}
                        />
                    </svg> */}
                </div>
            </div>
        </Link>
    );
};

export default TravelCard;
